import React from "react";
import { Box } from "@mui/material";
import { NJIM } from "../../theme/njimTheme";

// Generic business-type prefixes ("صيدلية …", "Pharmacy …") make every avatar look the same.
const GENERIC_PREFIXES = new Set(["صيدلية", "صيدليه", "مذخر", "pharmacy", "مستشفى", "مركز"]);

export const getInitials = (name?: string) => {
  const all = (name ?? "")
    .replace(/[/|\-–—()]+/g, " ")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  const parts =
    all.length > 1 && GENERIC_PREFIXES.has(all[0].toLowerCase()) ? all.slice(1) : all;
  // Drop the Arabic definite article so "اليقين البنوك" doesn't become "اا".
  const words = parts.map((w) => (/^ال[\u0600-\u06FF]{2,}/.test(w) ? w.slice(2) : w));
  if (words.length === 0) return "";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0]}${words[1][0]}`.toUpperCase();
};

interface CodInitialsAvatarProps {
  name?: string;
  size?: number;
  selected?: boolean;
}

const CodInitialsAvatar: React.FC<CodInitialsAvatarProps> = ({
  name,
  size = 36,
  selected = false,
}) => (
  <Box
    aria-hidden
    sx={{
      width: size,
      height: size,
      borderRadius: "50%",
      flexShrink: 0,
      display: "grid",
      placeItems: "center",
      bgcolor: selected ? NJIM.mint : NJIM.ink,
      color: NJIM.white,
      fontSize: size <= 28 ? 11 : 13,
      fontWeight: 700,
      letterSpacing: "0.02em",
    }}
  >
    {getInitials(name) || "—"}
  </Box>
);

export default CodInitialsAvatar;
